module.exports = __webpack_public_path__ + "img/zhixinz.c3cf3f60.png";